import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

export const accountReceivableAllArDetailsRowSchema = z.object({
  amount_original: currencyInput.querySchema(),
  balance_due: currencyInput.querySchema(),
  total_paid: currencyInput.querySchema(),
  client_name: z.string(),
  account_number: z.number(),
  invoice_number: z.string(),
  invoice_date: z.string(),
  due_date: z.string(),
  invoice_amount: z.string(),
  brand_name: z.string(),
  status: z.string(),
  state: z.string(),
});

export type AccountReceivableAllArDetailsRow = z.infer<typeof accountReceivableAllArDetailsRowSchema>;

export const accountReceivableAllArDetailsQuerySchema = z.object({
  data: z.array(accountReceivableAllArDetailsRowSchema),
  total: z.number(),
});

export type AccountReceivableAllArDetailsQuerySchema = z.infer<typeof accountReceivableAllArDetailsQuerySchema>;
